//@flow

// Vendors
import React, { useState } from 'react';
import classnames from 'classnames';

// Components
import { InputGroup, InputPassword, Content } from '../../..';
import InputPasswordReq from './InputPasswordReq';

import './InputGroupConfirmPassword.scss';

type Props = {
  className?: string,
  formikProps: FormikProps,
};

/**
 * @visibleName Confirm Password
 */

const InputGroupConfirmPassword = ({
  className,
  formikProps,
  ...props
}: Props) => {
  const [passwordChecklist, setPasswordChecklist] = useState(false);

  const [containsMinC, setcontainsMinC] = useState(false);
  const [allValid, setAllValid] = useState(false);

  const passwordReqData = [
    ['A minimum of 15 characters', containsMinC],    
  ];
  const validatePassword = updatedPassword => {    
    if (updatedPassword.length >= 15) setcontainsMinC(true);
    else setcontainsMinC(false);
    if (containsMinC) setAllValid(true);
    else setAllValid(false);
  };

  const showFocused = () => {
    setPasswordChecklist(!passwordChecklist);
  };

  return (
    <InputGroup
      {...props}
      className={classnames('input-group-confirm-password', className)}
    >
      <InputPassword
        name="password"
        label={<Content type="Labels" id="EnterPassword" />}
        formikProps={formikProps}
        onKeyUp={e => validatePassword(e.target.value)}
        onFocus={showFocused}
        onBlur={showFocused}
        autoComplete="new-password"
        className="input-margin"
        maxLength="64"
        />
      {passwordChecklist && (
        <div className="password-helper-container">
          {passwordReqData.map(data => (
            <InputPasswordReq data={data} />
          ))}
        </div>
      )}

      <InputPassword
        name="confirmPassword"
        label={<Content type="Labels" id="ConfirmPassword" />}
        className="input-password-confirm"
        autoComplete="new-password"
        formikProps={formikProps}
        maxLength="64"
      />
    </InputGroup>
  );
};

export default InputGroupConfirmPassword;
